const openUrl = (url, { target = '_blank', rel = 'noopener' } = {}) => {
  // most reliable method for cross browser support.
  const a = document.createElement('a')
  a.href = url
  a.target = target
  a.rel = rel
  setTimeout(() => {
    a.click()
  }, 0)
  return a
}

export default openUrl
